import React, { useState } from "react";
import { Box, Paper, Tabs, Tab } from "@mui/material";
import {
    LocationOn as LocationOnIcon,
    Badge as BadgeIcon,
    AccountTree as AccountTreeIcon,
    Category as CategoryIcon,
} from "@mui/icons-material";
import { Chip, Typography as MuiTypography } from "@mui/material";
import LocationManagement from "./LocationManagement";
import DesignationManagement from "./DesignationManagement";
import DivisionManagement from "./DivisionManagement";
import EmployeeCategoryManagement from "./EmployeeCategoryManagement";
import HeaderBannerPage from "../components/HeaderBannerPage";

const LookupManagement = () => {
const [tab, setTab] = useState(0);

return (
    <Box sx={{ width: "100%", minHeight: "100vh" }}>
        <HeaderBannerPage />
        <Box sx={{ maxWidth: 900, mx: "auto", mt: 4, px: 2 }}>
        <Paper
            elevation={0}
            sx={{
            p: 3,
            mb: 3,
            borderRadius: "12px",
            background: "linear-gradient(135deg, #1e0153 0%, #154c79 100%)",
            color: "#ffffff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
            boxShadow: "0px 4px 12px rgba(30, 1, 83, 0.15)",
        }}
    >
        <Box>
        <Chip
            label="ADMIN ONLY"
            color="error"
            size="small"
            sx={{
            fontWeight: "bold",
            mb: 1,
            fontSize: "11px",
            letterSpacing: "0.5px",
            backgroundColor: "#ef4444",
            }}
        />
        <MuiTypography
            variant="h5"
            sx={{ fontWeight: 700, mb: 0.5, fontFamily: "'Poppins', sans-serif" }}
        >
            Lookup Data Management
        </MuiTypography>
        <MuiTypography variant="body2" sx={{ opacity: 0.85, fontSize: "13px" }}>
            Manage Locations, Designations, Divisions, and Employee Categories
        </MuiTypography>
        </Box>
        </Paper>
        <Paper sx={{ mb: 3 }}>
    <Tabs
        value={tab}
        onChange={(e, val) => setTab(val)}
        variant="fullWidth"
        sx={{
        "& .MuiTabs-indicator": { backgroundColor: "#142c54" },
        "& .MuiTab-root.Mui-selected": { color: "#142c54" },
        }}
    >
        <Tab icon={<LocationOnIcon fontSize="small" />} iconPosition="start" label="Locations" />
        <Tab icon={<BadgeIcon fontSize="small" />} iconPosition="start" label="Designation" />
        <Tab icon={<AccountTreeIcon fontSize="small" />} iconPosition="start" label="Division" />
        <Tab icon={<CategoryIcon fontSize="small" />} iconPosition="start" label="Employee Category" />
    </Tabs>
    </Paper>

{tab === 0 && <LocationManagement />}
        {tab === 1 && <DesignationManagement />}
        {tab === 2 && <DivisionManagement />}
        {tab === 3 && <EmployeeCategoryManagement />}
        </Box>
    </Box>
    );
};

export default LookupManagement;